import moment from 'moment'

const healthCoachSchema = ({ data, headers }) => {
  const status = data.program_status.split('_').join(' ')
  return (
    <tr className='text-gray-600'>
      {headers.map((key) => {
        switch (key.toUpperCase()) {
          case 'FULL NAME':
            return <td className='pl-3 pr-5 py-5 font-semibold'>{data.full_name}</td>

          case 'EMAIL':
            return <td className='pl-3 pr-5 py-5 '>{data.email}</td>

          case 'PROGRAM NAME':
            return <td className='pl-3 pr-5 py-5'>{data.program_name}</td>

          case 'PROGRAM STATUS':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span className='px-2 inline-flex leading-7 font-semibold rounded-full bg-green-100 text-green-700'>{status === 'received' ? 'completed' : status}</span>
              </td>
            )

          case 'DURATION':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.duration}</span>
              </td>
            )

          case 'CUSTOMER TYPE':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.customer_type}</span>
              </td>
            )

          case 'ENROLLMENT START & END DATE':
            const startDate = moment(data.enrollment_start_date_end_date.start_date).format('DD MMM YYYY')
            const endDate = moment(data.enrollment_start_date_end_date.end_date).format('DD MMM YYYY')
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{`${startDate} - ${endDate}`}</span>
              </td>
            )
        }
      })}
    </tr>
  )
}

export default healthCoachSchema